// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HiiZ2","title":"styles_title__r8F-M","subtitle":"styles_subtitle__nvRE-","paragraph":"styles_paragraph__sdEx-","uls":"styles_uls__56Wpg"};